import { useRef } from "react";

export const useIceRestartMetrics = () => {
  const metricsRef = useRef({
    attempts: 0,
    successes: 0,
    failures: 0,
    lastDurationMs: null,
    history: [],
  });

  const markAttempt = () => {
    metricsRef.current.attempts += 1;
    metricsRef.current._start = performance.now();
  };

  const markSuccess = () => {
    const duration = performance.now() - metricsRef.current._start;

    metricsRef.current.successes += 1;
    metricsRef.current.lastDurationMs = duration;
    metricsRef.current.history.push({
      success: true,
      duration,
      ts: Date.now(),
    });
  };

  const markFailure = () => {
    metricsRef.current.failures += 1;
    metricsRef.current.history.push({
      success: false,
      ts: Date.now(),
    });
  };

  return {
    metrics: metricsRef,
    markAttempt,
    markSuccess,
    markFailure,
  };
};
